<template>
  <v-container fluid>
    <div class="app">
      <div class="user-wrapper">
        <div
          class="
            md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50
          "
        >
          <div class="md-card md-theme-default">
            <div
              class="
                md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50
              "
            >
              <div class="md-card-content">
                <div class="search_customer">
                  <div class="header_title">Admin Users</div>
                  <v-row>
                    <v-col md="2">
                      <div style="width: 120px; float: left" class="per-page">
                        <v-select
                          outlined
                          :menu-props="{ bottom: true, offsetY: true }"
                          background-color="#fff"
                          filled
                          v-model="perPage"
                          label="Per Page"
                          :items="[10, 15, 25, 50]"
                          @change="getUsersList"
                        ></v-select>
                      </div>
                    </v-col>
                    <v-spacer></v-spacer>

                    <!-- <v-col md="2" class="text-right">
                      <v-btn dark color="#00b0af" @click="addUserModal">
                        <v-icon>mdi-plus</v-icon> User
                      </v-btn>
                    </v-col> -->
                  </v-row>
                </div>
                <div>
                  <div
                    class="md-content md-table md-theme-default table_borders"
                    table-header-color="orange"
                    value
                  >
                    <div
                      class="
                        md-content
                        md-table-content
                        md-scrollbar
                        md-theme-default
                      "
                    >
                      <table class="listing_table">
                        <thead class="md-card-header">
                          <tr>
                            <th class="md-table-head ten">
                              <div
                                class="
                                  md-table-head-container md-ripple md-disabled
                                "
                              >
                                <div class="md-table-head-label">Username</div>
                                <div class="search_column">
                                  <v-autocomplete
                                    clearable
                                    solo
                                    filled
                                    label="Username"
                                    v-model="searchParams.username"
                                    item-value="username"
                                    item-text="username"
                                    :items="usernames"
                                    :loading="isLoading"
                                    @update:search-input="
                                      getFilterData('username', $event)
                                    "
                                    @change="getUsersList"
                                  >
                                  </v-autocomplete>
                                </div>
                              </div>
                            </th>

                            <th class="md-table-head ten">
                              <div
                                class="
                                  md-table-head-container md-ripple md-disabled
                                "
                              >
                                <div class="md-table-head-label">Name</div>
                                <div class="search_column">
                                  <v-autocomplete
                                    clearable
                                    solo
                                    filled
                                    outlined
                                    background-color="#fff"
                                    label="Name"
                                    v-model="searchParams.name"
                                    item-value="name"
                                    item-text="name"
                                    :items="names"
                                    :loading="isLoading"
                                    @update:search-input="
                                      getFilterData('name', $event)
                                    "
                                    @change="getUsersList"
                                  >
                                  </v-autocomplete>
                                </div>
                              </div>
                            </th>

                            <th class="md-table-head ten">
                              <div
                                class="
                                  md-table-head-container md-ripple md-disabled
                                "
                              >
                                <div class="md-table-head-label">Email</div>
                                <div class="search_column">
                                  <v-autocomplete
                                    clearable
                                    solo
                                    filled
                                    outlined
                                    background-color="#fff"
                                    label="Email"
                                    v-model="searchParams.email"
                                    item-value="email"
                                    item-text="email"
                                    :items="emails"
                                    :loading="isLoading"
                                    @update:search-input="
                                      getFilterData('email', $event)
                                    "
                                    @change="getUsersList"
                                  >
                                  </v-autocomplete>
                                </div>
                              </div>
                            </th>

                            <th class="md-table-head ten">
                              <div
                                class="
                                  md-table-head-container md-ripple md-disabled
                                "
                              >
                                <div class="md-table-head-label">Mobile</div>
                                <div class="search_column">
                                  <v-autocomplete
                                    clearable
                                    solo
                                    filled
                                    outlined
                                    background-color="#fff"
                                    label="Mobile"
                                    v-model="searchParams.mobile"
                                    item-value="mobile"
                                    item-text="mobile"
                                    :items="mobiles"
                                    :loading="isLoading"
                                    @update:search-input="
                                      getFilterData('mobile', $event)
                                    "
                                    @change="getUsersList"
                                  ></v-autocomplete>
                                </div>
                              </div>
                            </th>

                            <th class="five"></th>
                            <th class="five"></th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            class="md-table-row"
                            v-for="(user, i) in userList"
                            :key="i"
                          >
                            <!---->

                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                {{ user.username }}
                              </div>
                            </td>
                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                {{ user.first_name }} {{ user.last_name || "" }}
                              </div>
                            </td>
                            <td class="md-table-cell">
                              <div
                                class="md-table-cell-container text-truncate"
                                style="max-width: 220px"
                              >
                                {{ user.email }}
                              </div>
                            </td>
                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                {{ user.mobile }}
                              </div>
                            </td>

                            <td class="md-table-cell">
                              <div
                                class="md-table-cell-container"
                                v-if="
                                  user.id != $store.getters.userInfo.user_id
                                "
                              >
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      v-bind="attrs"
                                      v-on="on"
                                      v-if="
                                        user.id !=
                                          $store.getters.getLoggedInUserID &&
                                        user.is_admin == 0
                                      "
                                      fab
                                      dark
                                      x-small
                                      color="red"
                                      value="nearby"
                                      @click="
                                        deleteConfirm({ index: i, id: user.id })
                                      "
                                    >
                                      <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                  </template>
                                  Delete
                                </v-tooltip>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <v-pagination
                    v-model="page"
                    :length="totalPages"
                  ></v-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-dialog v-model="addModal" width="60%" scrollable @input="closeAddUser">
        <v-form ref="form" v-model="valid">
          <v-card>
            <v-card-title class="headline"
              >{{ editFlag ? "Edit" : "Add" }} User</v-card-title
            >
            <v-card-text class="form_bg pt-4">
              <v-row no-gutters justify="center">
                <v-col cols="4">
                  <image-upload
                    @upload="
                      (data) => {
                        userData.image = data;
                      }
                    "
                    @remove="
                      () => {
                        userData.image = null;
                      }
                    "
                    ref="image_upload"
                    :height="250"
                    :image_path="userData.image_path"
                    text="Click to upload profile image"
                  ></image-upload>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="userData.username"
                    label="Username*"
                    required
                    outlined
                    autocomplete="off"
                    background-color="#fff"
                    :rules="[(v) => !!v || 'Username is required']"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6" v-if="!editFlag">
                  <v-text-field
                    :type="hidePassword ? 'password' : 'text'"
                    :append-icon="hidePassword ? 'mdi-eye-off' : 'mdi-eye'"
                    label="Password*"
                    outlined
                    autocomplete="new-password"
                    background-color="#fff"
                    v-model="userData.password"
                    @click:append="hidePassword = !hidePassword"
                    required
                    :rules="[(v) => !!v || 'Password is required']"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="userData.first_name"
                    label="First name*"
                    outlined
                    background-color="#fff"
                    required
                    :rules="[(v) => !!v || 'First name is required']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="userData.last_name"
                    label="Last name*"
                    outlined
                    background-color="#fff"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <mobile-field
                    v-model="userData.mobile"
                    label="Mobile*"
                  ></mobile-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="userData.email"
                    label="Email*"
                    outlined
                    background-color="#fff"
                    required
                    :rules="[
                      (v) => !!v || 'E-mail is required',
                      (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                    ]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-expansion-panels
                v-if="
                  typeof userPermissions !== 'undefined' &&
                  userPermissions.length > 0
                "
                focusable
                flat
              >
                <template
                  v-for="(userRolePermission, rIndex) in userPermissions"
                >
                  <v-expansion-panel
                    :key="rIndex"
                    v-if="userRolePermission != null"
                  >
                    <v-expansion-panel-header color="transparent">
                      <span>{{ userRolePermission.title }} Permission</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content color="#edf9ff" class="pt-4">
                      <v-row>
                        <v-col>
                          <v-expansion-panels>
                            <template
                              v-for="(
                                modules, mIndex
                              ) in userRolePermission.permissions"
                            >
                              <v-expansion-panel :key="`${rIndex}_${mIndex}`">
                                <v-expansion-panel-header>{{
                                  modules.module_name
                                }}</v-expansion-panel-header>
                                <v-expansion-panel-content class="pt-3">
                                  <table class="permission_table">
                                    <thead>
                                      <tr>
                                        <th>Module</th>
                                        <th>Read</th>
                                        <th>Write</th>
                                        <th>Delete</th>
                                        <th>Export</th>
                                        <th>Backfill</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="(
                                          permission, index
                                        ) in modules.sub_modules"
                                        :key="`${rIndex}_${mIndex}_${index}`"
                                      >
                                        <td>
                                          {{ permission.sub_module_name }}
                                        </td>
                                        <td>
                                          <v-btn
                                            icon
                                            :color="
                                              permission.allow_read == 1
                                                ? 'success'
                                                : 'error'
                                            "
                                            @click="
                                              changeModulePermission(
                                                'read',
                                                rIndex,
                                                mIndex,
                                                index
                                              )
                                            "
                                          >
                                            <v-icon>{{
                                              permission.allow_read == 1
                                                ? "mdi-check"
                                                : "mdi-close"
                                            }}</v-icon>
                                          </v-btn>
                                        </td>
                                        <td>
                                          <v-btn
                                            icon
                                            :color="
                                              permission.allow_write == 1
                                                ? 'success'
                                                : 'error'
                                            "
                                            @click="
                                              changeModulePermission(
                                                'add',
                                                rIndex,
                                                mIndex,
                                                index
                                              )
                                            "
                                          >
                                            <v-icon>{{
                                              permission.allow_write == 1
                                                ? "mdi-check"
                                                : "mdi-close"
                                            }}</v-icon>
                                          </v-btn>
                                        </td>
                                        <td>
                                          <v-btn
                                            icon
                                            :color="
                                              permission.allow_delete == 1
                                                ? 'success'
                                                : 'error'
                                            "
                                            @click="
                                              changeModulePermission(
                                                'delete',
                                                rIndex,
                                                mIndex,
                                                index
                                              )
                                            "
                                          >
                                            <v-icon>{{
                                              permission.allow_delete == 1
                                                ? "mdi-check"
                                                : "mdi-close"
                                            }}</v-icon>
                                          </v-btn>
                                        </td>
                                        <td>
                                          <v-btn
                                            icon
                                            :color="
                                              permission.allow_export == 1
                                                ? 'success'
                                                : 'error'
                                            "
                                            @click="
                                              changeModulePermission(
                                                'export',
                                                rIndex,
                                                mIndex,
                                                index
                                              )
                                            "
                                          >
                                            <v-icon>{{
                                              permission.allow_export == 1
                                                ? "mdi-check"
                                                : "mdi-close"
                                            }}</v-icon>
                                          </v-btn>
                                        </td>
                                        <td>
                                          <v-btn
                                            icon
                                            :color="
                                              permission.allow_backfill == 1
                                                ? 'success'
                                                : 'error'
                                            "
                                            @click="
                                              changeModulePermission(
                                                'backfill',
                                                rIndex,
                                                mIndex,
                                                index
                                              )
                                            "
                                          >
                                            <v-icon>{{
                                              permission.allow_backfill == 1
                                                ? "mdi-check"
                                                : "mdi-close"
                                            }}</v-icon>
                                          </v-btn>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </template>
                          </v-expansion-panels>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </template>
              </v-expansion-panels>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="ma-2 white--text blue-color"
                text
                @click="closeAddUser"
                >Close</v-btn
              >
              <v-btn
                v-if="editFlag"
                class="ma-2 yellow-color"
                text
                @click="openChangePassword"
                >Change Password</v-btn
              >

              <v-btn
                class="ma-2 white--text teal-color"
                text
                @click="addUpdateUser"
                >{{ editFlag ? "Update User" : "Add User" }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog
        v-model="passwordDialog"
        max-width="400"
        scrollable
        @input="closeChangePassword"
      >
        <v-form ref="passowrd_form" v-model="valid">
          <v-card>
            <v-card-title class="headline">Change User Password</v-card-title>
            <v-card-text class="form_bg pt-4">
              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field
                    :type="password.new_hide ? 'password' : 'text'"
                    :append-icon="password.new_hide ? 'mdi-eye-off' : 'mdi-eye'"
                    name="Password"
                    label="New Password"
                    outlined
                    background-color="#fff"
                    v-model="password.password"
                    @click:append="password.new_hide = !password.new_hide"
                    required
                    :rules="[
                      (v) => !!v || 'Password is required',
                      (v) =>
                        (v && v.length >= 6) ||
                        'Password should be atleast 6 characters long',
                    ]"
                  />
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field
                    :type="password.confirm_hide ? 'password' : 'text'"
                    :append-icon="
                      password.confirm_hide ? 'mdi-eye-off' : 'mdi-eye'
                    "
                    name="Password"
                    label="Confirm Password"
                    outlined
                    background-color="#fff"
                    v-model="password.password_confirmation"
                    @click:append="
                      password.confirm_hide = !password.confirm_hide
                    "
                    required
                    :rules="confirmRules()"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="ma-2 white--text blue-color"
                text
                @click="closeChangePassword"
                >Close</v-btn
              >
              <v-btn
                class="ma-2 white--text teal-color"
                text
                @click="changePassword"
                >Change Password</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <confirm-model
        v-bind="confirmModel"
        @confirm="confirmActions"
        @close="confirmModel.id = null"
      ></confirm-model>
    </div>
  </v-container>
</template>

<script>
import ConfirmModel from "@/components/Confirmation/ConfirmModel";
export default {
  components: {
    ConfirmModel,
  },
  data() {
    return {
      searchParams: {
        role_ids: [],
        username: null,
        name: null,
        mobile: null,
        email: null,
      },
      items: [],
      userData: { mobile: null },
      userList: [],
      editFlag: false,
      addModal: false,
      rolePermissions: [],
      userPermissions: [],
      hidePassword: true,
      roles: [],
      page: 1,
      perPage: 6,
      valid: true,
      confirmModel: {
        id: null,
        title: null,
        description: null,
      },
      password: { current_hide: true, new_hide: true, confirm_hide: true },
      passwordDialog: false,
      mobiles: [],
      emails: [],
      names: [],
      usernames: [],
      totalPages: 1,
      isLoading: false,
    };
  },
  mounted() {
    this.getUsersList();
  },
  computed: {
    venues() {
      let currentVenueCode = this.$store.getters.venueInfo.code;
      return this.$store.getters.userVenues.filter(
        (item) => item.code != currentVenueCode
      );
    },
    userProfileModule() {
      return process.env.VUE_APP_USER_PROFILE_MODULE;
    },
  },
  watch: {
    page() {
      this.getUsersList();
    },
  },
  methods: {
    getFilterData(type, val) {
      if (
        val == "All" ||
        val == null ||
        this.searchParams[type] == val ||
        val == ""
      )
        return;
      this.isLoading = true;
      this.$http
        .get(`venues/users/filters?field=${type}&search=${val}`)
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.isLoading = false;
            if (type == "name") {
              this.names = response.data.data;
              this.names.unshift({ name: "All" });
            } else if (type == "mobile") {
              this.mobiles = response.data.data;
              this.mobiles.unshift({ mobile: "All" });
            } else if (type == "username") {
              this.usernames = response.data.data;
              this.usernames.unshift({ username: "All" });
            } else if (type == "email") {
              this.emails = response.data.data;
              this.emails.unshift({ email: "All" });
            }
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    getUsersList() {
      this.showLoader("Loading..");
      let url = `&per_page=${this.perPage}`;
      for (const [key, value] of Object.entries(this.searchParams)) {
        if (value && value != "All") {
          if (Array.isArray(value) && value.length > 0) {
            url += `&${value
              .map((role, index) => `${key}[${index}]=${role}`)
              .join("&")}`;
          } else if (!Array.isArray(value)) {
            url += `&${key}=${value}`;
          }
        }
      }
      this.$http
        .get(`users?page=${this.page}${url}`)
        .then((response) => {
          if (response.status == 200 && response.data.status == true) {
            this.userList = response.data.data;
            this.totalPages = response.data.total_pages;
            this.hideLoader();
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    addUserModal() {
      this.userData = {
        username: null,
        password: null,
        name: null,
        email: null,
        mobile: null,
        venue_ids: [],
        role: [],
      };
      this.userPermissions = [];
      this.editFlag = false;
      this.addModal = true;
      setTimeout(() => {
        this.$refs["image_upload"].cancel();
        this.$refs.form.resetValidation();
      });
    },
    deleteConfirm(data) {
      this.confirmModel = {
        id: data.id,
        title: "Do you want to delete this user?",
        description:
          "By clicking <b>Yes</b> you can confirm the operation.  Do you need to continue your action ?",
        type: "delete_post",
      };
    },
    confirmActions(data) {
      if (data.type == "delete_post") {
        this.deleteUser(data.id);
      }
      this.confirmModel.id = null;
    },
    addUpdateUser() {
      if (!this.$refs.form.validate()) {
        this.showError("Please fill all required fields");
        return;
      }
      event.preventDefault();
      this.showLoader();
      let formData = new FormData();
      this.userPermissions.forEach((roles, ri) => {
        formData.set(`roles[${ri}][id]`, roles.role_id);
        let pi = 0;
        roles.permissions.forEach((modules) => {
          modules.sub_modules.forEach((permission) => {
            formData.set(
              `roles[${ri}][permissions][${pi}][venue_subscription_id]`,
              permission.venue_subscription_id
            );
            formData.set(
              `roles[${ri}][permissions][${pi}][allow_delete]`,
              permission.allow_delete
            );
            formData.set(
              `roles[${ri}][permissions][${pi}][allow_export]`,
              permission.allow_export
            );
            formData.set(
              `roles[${ri}][permissions][${pi}][allow_read]`,
              permission.allow_read
            );
            formData.set(
              `roles[${ri}][permissions][${pi}][allow_write]`,
              permission.allow_write
            );
            formData.set(
              `roles[${ri}][permissions][${pi}][allow_backfill]`,
              permission.allow_backfill
            );
            pi += 1;
          });
        });
      });
      if (this.userData.venue_ids.length > 0) {
        this.userData.venue_ids.forEach((venueId, index) => {
          formData.set(`venue_ids[${index}]`, venueId);
        });
      }
      formData.set("username", this.userData.username);
      if (this.userData.id == null) {
        formData.set("password", this.userData.password);
      }
      formData.set("first_name", this.userData.first_name);
      formData.set("last_name", this.userData.last_name);
      formData.set("email", this.userData.email);
      formData.set("mobile", this.userData.mobile);
      if (this.userData.image != null) {
        formData.set("image", this.userData.image);
      }
      this.$http
        .post(
          `venues/users${
            this.userData.id != null ? "/" + this.userData.id : ""
          }`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data; boundary=${form._boundary}",
            },
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data.status == true) {
            this.addModal = false;
            const data = response.data.data;
            this.showSuccess(response.data.message);
            this.hideLoader();
            this.getUsersList();
            if (this.userData.id == this.$store.getters.userInfo.user_id) {
              const user = {
                username: data.username,
                email: data.email,
                first_name: data.first_name,
                last_name: data.last_name,
                mobile: data.mobile,
                image_path: data.profile_image,
              };
              this.$store.commit("update_user_info", user);
              this.$store.dispatch("loadPermissions").then((response) => {
                if (response) this.showSuccess("Permission updated");
              });
            }
          }
        })
        .catch((error) => {
          this.hideLoader();
          this.errorChecker(error);
        });
    },

    deleteUser(id) {
      this.$http
        .delete("venues/users/" + id)
        .then((response) => {
          if (response.status == 200) {
            this.showSuccess("User Deleted Successfully.");
            this.getUsersList();
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    closeAddUser() {
      this.addModal = false;
      this.$refs.form.resetValidation();
    },

    changeModulePermission(type, roleIndex, moduleIndex, subIndex) {
      let currentPermission =
        this.userPermissions[roleIndex].permissions[moduleIndex].sub_modules[
          subIndex
        ];
      if (type == "read") {
        if (currentPermission.module_name == this.userProfileModule) {
          this.showError("Error! User basic read permission cannot be changed");
          return;
        }
        if (
          this.$store.getters.userInfo.user_id == this.userData.id &&
          currentPermission.slug == this.$modules.settings.users.slug
        ) {
          this.showError("Access for current user cannot be disabled");
          return;
        }
        this.userPermissions[roleIndex].permissions[moduleIndex].sub_modules[
          subIndex
        ].allow_read = currentPermission.allow_read == 1 ? 0 : 1;
      } else if (type == "add") {
        this.userPermissions[roleIndex].permissions[moduleIndex].sub_modules[
          subIndex
        ].allow_write = currentPermission.allow_write == 1 ? 0 : 1;
      } else if (type == "delete") {
        this.userPermissions[roleIndex].permissions[moduleIndex].sub_modules[
          subIndex
        ].allow_delete = currentPermission.allow_delete == 1 ? 0 : 1;
      } else if (type == "export") {
        this.userPermissions[roleIndex].permissions[moduleIndex].sub_modules[
          subIndex
        ].allow_export = currentPermission.allow_export == 1 ? 0 : 1;
      } else if (type == "backfill") {
        this.userPermissions[roleIndex].permissions[moduleIndex].sub_modules[
          subIndex
        ].allow_backfill = currentPermission.allow_backfill == 1 ? 0 : 1;
      }
      this.$forceUpdate();
    },
    closeChangePassword() {
      this.passwordDialog = false;
      this.addModal = true;
      this.password = {
        current_hide: true,
        new_hide: true,
        confirm_hide: true,
      };
    },
    openChangePassword() {
      this.passwordDialog = true;
      this.addModal = false;
      this.password.user_id = this.userData.id;
    },
    changePassword() {
      if (!this.$refs.passowrd_form.validate()) {
        this.showError("Please fill all required fields");
        return;
      }
      this.showLoader();
      this.$http
        .put(`venues/users/${this.password.user_id}/password`, this.password)
        .then((response) => {
          if (response.status == 200) {
            this.hideLoader();
            this.showSuccess(response.data.message);
            this.closeChangePassword();
          }
        })
        .catch((error) => {
          this.hideLoader();
          this.errorChecker(error);
        });
    },
    confirmRules() {
      let rules = [];
      if (this.password.password_confirmation == null) {
        rules.push("Confirm password is required");
      }
      if (this.password.password_confirmation != this.password.password) {
        rules.push("Confirm password does not match");
      }
      return rules;
    },
  },
};
</script>

<style scoped>
.user-wrapper {
  margin: 0px 10px 20px 10px;
}
.permission_table {
  width: 100%;
  text-align: center !important;
}
.permission_table th {
  text-align: center !important;
}
.permission_table td,
.permission_table th {
  border: 1px solid #ddd;
  padding: 8px;
}

.permission_table tr {
  background-color: #f2f2f2;
}
.permission_table tbody td:first-child {
  font-weight: bolder;
  font-size: 13px;
}

.permission_table tr:hover {
  background-color: #ddd;
}
.permission_table .header {
  background-color: rgb(209, 209, 209);
}

.permission_table th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #066a8c;
  color: white;
}
</style>
